import { render, staticRenderFns } from "./Regional_analysis_right.vue?vue&type=template&id=b14ff22a&scoped=true"
import script from "./Regional_analysis_right.vue?vue&type=script&lang=js"
export * from "./Regional_analysis_right.vue?vue&type=script&lang=js"
import style0 from "./Regional_analysis_right.vue?vue&type=style&index=0&id=b14ff22a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14ff22a",
  null
  
)

export default component.exports